/* unplugin-vue-components disabled */import { render } from "./audio.vue?vue&type=template&id=0ff7c575&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"

import "./audio.vue?vue&type=style&index=0&id=0ff7c575&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff7c575"],['__file',"src/components/ai-chat-v2/ai-file/audio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ff7c575"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ff7c575', __exports__)) {
    api.reload('0ff7c575', __exports__)
  }
  
  module.hot.accept("./audio.vue?vue&type=template&id=0ff7c575&scoped=true", () => {
    api.rerender('0ff7c575', render)
  })

}


export default __exports__